import React from "react";
import { RiCloseLargeLine } from "react-icons/ri";
import useSitePanel from "../store/useSitePanel";
import ListMenu from "./ListMenu";

function SitePanel() {
  const statusButton = useSitePanel((state) => state.status);
  const toggleButton = useSitePanel((state) => state.toggle);

  return (
    <div className={`site-panel ${statusButton ? "opened" : "closed"}`}>
      <div className="wrapper">
        <div className="fixed w-full top-0 left-0 z-10 bg-[var(--base-color)]">
          <button onClick={toggleButton} className="p-4">
            <RiCloseLargeLine className="text-2xl text-white" />
          </button>
        </div>
        <ListMenu className="site-panel__menu" />
      </div>
    </div>
  );
}

export default SitePanel;
